import { Pipe, PipeTransform } from "@angular/core";
import { EmgStatus } from "app/main/shared/enums/SingularMessage.enum";

export const emgStatusName: Record<EmgStatus, string> = {
  [EmgStatus.Delivered]: "Entregado",
  [EmgStatus.InProcess]: "En proceso",
  [EmgStatus.Failed]: "Fallido",
  [EmgStatus.Deleted]: "Expirado",
  [EmgStatus.Expired]: "Expirado",
  [EmgStatus.Rejected]: "Rechazado",
  [EmgStatus.Canceled]: "Expirado",
  [EmgStatus.Queued]: "Encolado",
  [EmgStatus.Orphaned]: "No entregado",
  [EmgStatus.Relayed]: "Entregado al operador",
  [EmgStatus.Unknown]: "Entregado al operador",
};

@Pipe({
  name: "emgStatusName",
})
export class EmgStatusNamePipe implements PipeTransform {
  transform(statusNumber: number): unknown {
    if (!statusNumber) return "N/A";
    const name = emgStatusName[statusNumber];
    console.log("Status: ", { name, statusNumber });
    return name;
  }
}
